export default __webpack_public_path__ + "static/media/orange_heart2.538d39fe.svg";